import {
  AppBar,
  Box,
  Toolbar,
} from "@mui/material";

import UserActionsMenu from "~/components/login/UserActionsMenu";
import { Permission } from "~/hooks/permissions";
import PermissionOrWarn from "~/components/common/PermissionOrWarn";

export default function NoCommandCenterPermission() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        alignItems: "stretch",
      }}
    >
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ ml: "auto" }}>
            <UserActionsMenu />
          </Box>
        </Toolbar>
      </AppBar>
      <PermissionOrWarn permission={Permission.useWebApp} />
    </Box>
  )
}
